import React, { useEffect, useState } from "react";
import { $t } from "~/i18n.js";
import { Divider } from "antd";
import { BevoegdheidScore } from "./BevoegdheidScore.jsx";
import { _parseDate } from "~/lib/localize.js";
import { api } from "~/lib/api.js";
import { DateTimeFormat } from "~/components/date/DateTimeFormat.jsx";

export const BevoegdheidHistory = ({
  behaalde_bevoegdheid_id,
  currentBevoegdheid,
}) => {
  if (!behaalde_bevoegdheid_id || !currentBevoegdheid.score) return null;

  const [records, setRecords] = useState(null);

  useEffect(() => {
    let isMounted = true;
    if (behaalde_bevoegdheid_id) {
      api
        .get(`bevoegdheid/${behaalde_bevoegdheid_id}/bevoegdheid_history.json`)
        .then((res) => {
          if (isMounted) setRecords(res);
        });
    }
    return () => {
      isMounted = false;
    };
  }, [behaalde_bevoegdheid_id]);

  if (!records) return null;
  return (
    <div style={{ marginTop: 48 }}>
      <Divider orientation="left" plain>
        {$t("Historie")}
      </Divider>

      <div className="flightChanges">
        <table style={{ width: "100%" }}>
          <tbody>
            {currentBevoegdheid && (
              <tr>
                <td style={{ whiteSpace: "nowrap" }}>
                  <DateTimeFormat
                    date={currentBevoegdheid.date_assigned}
                    options={{
                      day: "2-digit",
                      month: "short",
                      year: "2-digit",
                    }}
                  />
                </td>
                <td>
                  <BevoegdheidScore score={currentBevoegdheid.score} />
                </td>
                <td className="truncate">
                  {currentBevoegdheid.instructeur_naam}
                </td>
                <td className="truncate">
                  {currentBevoegdheid.remark}{" "}
                  {currentBevoegdheid.date_geldig && (
                    <span className="gray" style={{ whiteSpace: "nowrap" }}>
                      {$t("tot")}{" "}
                      <DateTimeFormat
                        date={currentBevoegdheid.date_geldig}
                        options={{
                          day: "2-digit",
                          month: "short",
                          year: "2-digit",
                        }}
                      />
                    </span>
                  )}
                </td>
              </tr>
            )}

            {records?.map((record, key) => {
              return (
                <tr key={key}>
                  <td style={{ whiteSpace: "nowrap" }}>
                    <DateTimeFormat
                      date={record.date_assigned}
                      options={{
                        day: "2-digit",
                        month: "short",
                        year: "2-digit",
                      }}
                    />
                  </td>
                  <td>
                    <BevoegdheidScore score={record.score} />
                  </td>
                  <td className="truncate">{record.instructeur_naam}</td>
                  <td >
                    {record.remark}{" "}
                    {record.date_geldig && (
                      <span className="gray" style={{ whiteSpace: "nowrap" }}>
                        {$t("tot")}{" "}
                        <DateTimeFormat date={record.date_geldig} />
                      </span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
